import React from "react";
import { Outlet } from "react-router-dom";
import HeaderComponent from "./screens/Header/header.component";
import FooterComponent from "./screens/Footer/footer.component";

const LayoutWrapper = () => {
  return (
    <>
      <HeaderComponent />
      <Outlet />
      <FooterComponent />
    </>
  );
};

export default LayoutWrapper;
